import { Box } from '@mui/material'
import { RoomListItemWithStatus } from './room-list-item-with-status'
import { SearchSection } from '$common/room-list-search/search-section'
import { useForwardableRecentSearchedRooms } from '$logic/room-list/forward-list-search.react-hook'
import { t } from '$i18n'
import { deleteFromRecentSearch } from '$logic/room-list/room-list-search.service'
import { showDeleteSearchHistoryConfirmModal } from '$comp/modals/confirmation-dialog'
import { showRemoveMenu } from '$comp/modals/menus/remove-menu'

export function LastSearchedChats({
  selectionMap,
  hasSelection,
  onSelectedChange,
  onSelect,
}: {
  selectionMap: Record<string, boolean>
  hasSelection: boolean
  onSelectedChange: (selected: boolean, chatId: string) => unknown
  onSelect: (selectedRoomId: string) => unknown
}) {
  const recentSearchedRooms = useForwardableRecentSearchedRooms()

  const onMenu = (item: { id: string; type: 'USER' | 'ROOM' }) => {
    showRemoveMenu({ onRemove: () => deleteFromRecentSearch(item) })
  }

  return (
    <>
      {recentSearchedRooms.length > 0 && (
        <SearchSection
          primaryText={t('chatListSearch.recent')}
          secondaryText={t('chatListSearch.deleteAll')}
          secondaryAction={showDeleteSearchHistoryConfirmModal}
        />
      )}

      <Box sx={{ padding: '5px 0', backgroundColor: 'white' }}>
        {recentSearchedRooms.map(({ id, type }) =>
          type === 'USER' ? null : type === 'ROOM' ? (
            <RoomListItemWithStatus
              key={id}
              roomId={id}
              onSecondaryActionIconClick={() => onMenu({ type, id })}
              selectionMap={selectionMap}
              hasSelection={hasSelection}
              onSelectedChange={onSelectedChange}
              onSelect={onSelect}
            />
          ) : null,
        )}
      </Box>
    </>
  )
}

// TODO replace upper null with this
// onSecondaryActionIconClick={() =>
// onMenu({ type, id })} //
// SecondaryActionIcon={MenuIcon}
//   userId={id}
//   key={id}
// <UserListItemWithStatus
//   onClick={() => {
//     openUserProfile(id)
//     addToRecentSearch({ type, id })
//   }}
// />
